function Header({ title, subtitle, icon }) {
  return (
    <header className="page-header page-header-light bg-light mb-0">
      <div className="container">
        <div className="page-header-content pt-4">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto mt-4">
              <h1 className="page-header-title">
                <div className="page-header-icon">
                  <i data-feather={icon}></i>
                </div>
                {title}
              </h1>
              <div className="page-header-subtitle">
                {subtitle}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
